import React, { useEffect, useState, Fragment } from 'react';
export function UrgencySection() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 15,
    seconds: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) return {
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const [cupos, setCupos] = useState(72);
  useEffect(() => {
    const interval = setInterval(() => {
      setCupos(prev => {
        if (prev >= 92) return 92;
        return prev + 1;
      });
    }, 8000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  const barColor = cupos >= 80 ? 'from-[#D4A843] to-[#B8922E]' : 'from-[#E8C547] to-[#D4A843]';
  const barGlow = cupos >= 80 ? 'shadow-[0_0_20px_rgba(212,168,67,0.6)]' : 'shadow-[0_0_15px_rgba(212,168,67,0.4)]';
  return <section className="py-5 sm:py-10 bg-transparent relative overflow-hidden border-t border-gray-800" data-id="element-325">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[300px] h-[2px] bg-gradient-to-r from-transparent via-[#D4A843]/60 to-transparent" data-id="element-326"></div>
      <div className="max-w-md sm:max-w-2xl mx-auto px-3 sm:px-6 relative z-10" data-id="element-327">
        <h3 className="text-center text-sm sm:text-xl md:text-2xl font-black text-white tracking-wider mb-3 sm:mb-5 uppercase" data-id="element-328">
          El precio de lanzamiento termina en
        </h3>
        <div className="flex items-center justify-center gap-1.5 sm:gap-3 mb-4 sm:mb-6" data-id="element-329">
          {[{
          value: pad(timeLeft.hours),
          label: 'HORAS'
        }, {
          value: pad(timeLeft.minutes),
          label: 'MINUTOS'
        }, {
          value: pad(timeLeft.seconds),
          label: 'SEGUNDOS'
        }].map((item, i) => <Fragment key={item.label} data-id="element-330">
              {i > 0 && <span className="text-[#D4A843] text-3xl sm:text-5xl font-black -mt-3 sm:-mt-4" data-id="element-331">
                  :
                </span>}
              <div className="text-center" data-id="element-332">
                <div className="bg-[#1a1512] border border-[#D4A843]/40 rounded-lg px-2.5 sm:px-5 py-1.5 sm:py-3 min-w-[48px] sm:min-w-[80px] shadow-[0_0_10px_rgba(212,168,67,0.1)]" data-id="element-333">
                  <span className="text-[#D4A843] text-3xl sm:text-6xl font-black tabular-nums drop-shadow-[0_0_10px_rgba(212,168,67,0.5)]" data-id="element-334">
                    {item.value}
                  </span>
                </div>
                <span className="text-gray-500 text-[9px] sm:text-xs font-bold tracking-widest mt-0.5 block" data-id="element-335">
                  {item.label}
                </span>
              </div>
            </Fragment>)}
        </div>

        <div className="flex items-stretch justify-center gap-1.5 sm:gap-3 mb-4 sm:mb-6" data-id="element-336">
          <div className="flex-1 bg-[#1a1512] border border-[#D4A843]/30 rounded-lg p-2 sm:p-3 text-center" data-id="element-337">
            <p className="text-[#E8C547] text-[11px] sm:text-sm font-bold leading-tight" data-id="element-338">
              👥 Últimos cupos disponibles
            </p>
          </div>
          <div className="flex-1 bg-[#1a1512] border border-gray-600/40 rounded-lg p-2 sm:p-3 text-center" data-id="element-339">
            <p className="text-gray-300 text-[11px] sm:text-sm font-bold leading-tight" data-id="element-340">
              🚀 Oferta de Lanzamiento
            </p>
          </div>
          <div className="flex-1 bg-[#1a1512] border border-[#D4A843]/30 rounded-lg p-2 sm:p-3 text-center" data-id="element-341">
            <p className="text-[#E8C547] text-[11px] sm:text-sm font-bold leading-tight" data-id="element-342">
              📈 Precio sube al terminar
            </p>
          </div>
        </div>

        <div className="mb-4 sm:mb-6" data-id="element-343">
          <p className="text-center text-gray-400 text-[11px] sm:text-sm font-bold tracking-wider mb-1.5 uppercase" data-id="element-344">
            {cupos}% de cupos ocupados
          </p>
          <div className="w-full bg-[#121008] rounded-full h-3 sm:h-4 border border-gray-800 overflow-hidden" data-id="element-345">
            <div className={`h-full rounded-full bg-gradient-to-r ${barColor} ${barGlow} transition-all duration-1000 ease-out`} style={{
            width: `${cupos}%`
          }} data-id="element-346"></div>
          </div>
        </div>

        <div className="text-center" data-id="element-347">
          <button onClick={scrollToOffer} className="bg-gradient-to-b from-[#D4A843] to-[#9A7B24] text-white font-black text-sm sm:text-lg md:text-xl px-6 sm:px-10 py-2.5 sm:py-3.5 rounded-lg border-2 border-[#E8C547]/50 shadow-[0_0_20px_rgba(212,168,67,0.4)] hover:shadow-[0_0_30px_rgba(212,168,67,0.6)] hover:scale-105 active:scale-95 transition-all duration-200 tracking-wider uppercase animate-subtle-bounce" data-id="element-348">
            🔒 Asegurar mi precio ahora
          </button>
        </div>
      </div>
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[300px] h-[2px] bg-gradient-to-r from-transparent via-[#D4A843]/40 to-transparent" data-id="element-349"></div>
    </section>;
}